import Icon from '../components/Icon.vue'

Icon.register({
  'info-circle': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 8C119 8 8 119.1 8 256 8 393 119 504 256 504S504 393 504 256C504 119.1 393 8 256 8zM256 118C279.2 118 298 136.8 298 160S279.2 202 256 202 214 183.2 214 160 232.8 118 256 118zM312 372C312 378.6 306.6 384 300 384H212C205.4 384 200 378.6 200 372V348C200 341.4 205.4 336 212 336H224V272H212C205.4 272 200 266.6 200 260V236C200 229.4 205.4 224 212 224H276C282.6 224 288 229.4 288 236V336H300C306.6 336 312 341.4 312 348V372z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/info-circle.js
// module id = v6UW
// module chunks = 144